export enum AgendamentoViewProcedimentoTableMode {
  EDIT = 'EDIT',
  VALORES = 'VALORES',
  NONE = 'NONE',
}
